import Vue from "vue";
import AnimatedComponent from "../../components/Animated";

let els;

if ((els = document.querySelectorAll(".animated-container")).length > 0) {
  for (let i = 0; i < els.length; i++) {
    const el = els[i];

    new Vue({
      el,
      name: "Animated",
      components: { AnimatedComponent },
      data() {
        return {
          cities: [],
          opened: false,
          uniqid: i,
        };
      },
    });
  }
}
